import serverApi from '../services/serverApi';
import {mediaProviders} from 'inbox-common/dist/attachments';
import axios from 'axios';

const mediaTypesTranslation = {
  image: 'secure_picture',
  document: 'secure_document'
};

export async function uploadFileToMedia(file, contentType, onUploadProgress) {
  const {token, url} = await getUploadToken();
  const {upload_url, upload_token} = await getUploadUrl(token, url); // eslint-disable-line camelcase
  const mediaType = translateToMediaType(contentType);
  const uploadResult = await uploadToUrl({uploadUrl: upload_url, uploadToken: upload_token, mediaType, file, onUploadProgress}); // eslint-disable-line camelcase
  const uploadedFile = uploadResult[0];
  return {
    name: uploadedFile.original_file_name,
    url: uploadedFile.file_name,
    contentType: uploadedFile.mime_type,
    width: uploadedFile.width,
    height: uploadedFile.height,
    mediaProvider: mediaProviders.WIX_MEDIA
  };
}

function translateToMediaType(contentType) {
  if (contentType.startsWith('image')) {
    return mediaTypesTranslation.image;
  } else {
    return mediaTypesTranslation.document;
  }
}

function getUploadUrl(uploadToken, getUploadUrlApi) {
  return _fetch({
    method: 'get',
    url: getUploadUrlApi,
    headers: {
      Authorization: uploadToken
    }
  });
}

async function getUploadToken() {
  const {token, url} = await serverApi.getUploadToken();
  return {token: `APP ${token}`, url};
}

function uploadToUrl({uploadUrl, uploadToken, mediaType, file, onUploadProgress}) {
  const data = new FormData();
  data.append('upload_token', uploadToken);
  data.append('media_type', mediaType);
  data.append('file', file);
  data.append('siteMediaToken', uploadToken);
  data.append('ns', 'engage');
  return _fetch({
    method: 'post',
    url: uploadUrl,
    data,
    onUploadProgress: progressEvent => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      onUploadProgress(percentCompleted);
    }
  });
}

function _fetch(options) {
  return axios(options).then(response => response.data);
}



// WEBPACK FOOTER //
// ./chat-app/services/mediaManager.js